import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { RatingBadge } from "@/components/ReviewsSection";

export const ReviewsManager = ({ onChange }) => {
  const [reviews, setReviews] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/reviews").then((r) => setReviews(r.data));
  }, []);
  useEffect(load, [load]);

  const act = async (id, action) => {
    try {
      await api.put(`/admin/reviews/${id}/action`, { action });
      toast.success(action === "publish" ? "Review published" : "Review dismissed");
      load(); onChange?.();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div data-testid="admin-reviews-manager">
      <h2 className="font-display text-lg md:text-2xl text-foreground mb-2">Review holds & disputes</h2>
      <p className="text-sm text-muted-foreground mb-6">1-star reviews land here when the private resolution times out (7 days) or is still in progress. Publish makes them public; dismiss closes them quietly.</p>
      {reviews.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="admin-reviews-empty">No holds or disputes — the community is at peace.</p>
      ) : (
        <div className="space-y-4">
          {reviews.map((r) => (
            <div key={r.id} className="silk-card rounded-lg p-5" data-testid={`admin-review-${r.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
                <div>
                  <p className="text-sm text-foreground">{r.seeker_name} → {r.business_name} · {r.service_name}</p>
                  <p className="text-xs text-muted-foreground">
                    {r.status === "escalated" ? "Escalated (deadline passed)" : `On hold until ${new Date(r.hold_deadline).toLocaleDateString("en-CA")}`}
                  </p>
                </div>
                <RatingBadge rating={r.rating} />
              </div>
              {r.comment && <p className="text-sm text-muted-foreground mb-3">"{r.comment}"</p>}
              {(r.messages || []).length > 0 && (
                <div className="border border-border rounded-lg p-3 mb-4 max-h-40 overflow-y-auto space-y-2">
                  {r.messages.map((m, i) => (
                    <p key={i} className="text-xs text-muted-foreground"><span className="text-foreground">{m.sender_name}</span> ({m.sender_role}): {m.text}</p>
                  ))}
                </div>
              )}
              <div className="flex gap-2">
                <Button size="sm" className="rounded-full" data-testid={`admin-publish-review-${r.id}`} onClick={() => act(r.id, "publish")}>Publish review</Button>
                <Button size="sm" variant="outline" className="rounded-full" data-testid={`admin-dismiss-review-${r.id}`} onClick={() => act(r.id, "dismiss")}>Dismiss</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
